module.exports = __webpack_public_path__ + "img/literacy_eles_banner.dark.aef77d60.png";